import { render, staticRenderFns } from "./articleContent.vue?vue&type=template&id=289be0bb&scoped=true&"
import script from "./articleContent.vue?vue&type=script&lang=js&"
export * from "./articleContent.vue?vue&type=script&lang=js&"
import style0 from "./articleContent.vue?vue&type=style&index=0&id=289be0bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289be0bb",
  null
  
)

export default component.exports